import {
  ApiOutlined,
  AreaChartOutlined,
  CalendarOutlined,
  ControlOutlined,
  CreditCardOutlined,
  DeploymentUnitOutlined,
  DesktopOutlined,
  MenuOutlined,
  PoweroffOutlined,
  SafetyCertificateOutlined,
  SwapOutlined,
  SyncOutlined,
  UnorderedListOutlined,
  UserOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { Button, Layout, Menu, theme } from "antd";
import SubMenu from "antd/es/menu/SubMenu";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import {
  getItemFromStorage
} from "../../../helpers/storage";
import { useIsMobileHook } from "../../../utils/WindowHooks";
import "./PanelLayout.scss";
import {getUser, isSuperUser, userHasPermission} from "../../../helpers/user";
import AccountSelectionModal from "../AccountSelectionModal/AccountSelectionModal";

const { Header, Content, Sider } = Layout;

const navItems = [
  {
    key: "0",
    icon: React.createElement(AreaChartOutlined),
    path: "/",
    label: "Dashboard",
    permission: "",
  },
  {
    key: "1",
    icon: React.createElement(CreditCardOutlined),
    label: "Links de Pagamento",
    disabled: true,
    permission: "list_online_sells",
    children: [
      {
        key: "1-1",
        label: "Nova cobrança",
        path: "/pagamento/criar",
        permission: "add_online_sells",
      },
      {
        key: "1-2",
        label: "Listar cobranças",
        path: "/pagamentos",
        permission: "list_online_sells",
      },
    ],
  },
  {
    key: "1.5",
    icon: React.createElement(SyncOutlined),
    label: "Assinaturas",
    permission: "list_subscription_plan",
    children: [
      {
        key: "1.5-1",
        label: "Listar Assinaturas",
        path: "/assinaturas",
        permission: "list_subscription_plan",
      },
      {
        key: "1.5-2",
        label: "Nova Assinatura",
        path: "/assinatura/criar",
        permission: "add_subscription_plan",
      },
    ],
  },
  {
    key: "2",
    icon: React.createElement(UnorderedListOutlined),
    label: "Minhas Vendas",
    children: [
      {
        key: "2-1",
        label: "Listar vendas",
        path: "/listagem-vendas",
        permission: "list_transactions",
      },
      {
        key: "2-2",
        label: "Agenda de recebimento",
        path: "/listagem-recebiveis",
        permission: "list_receivables",
      },
      {
        key: "2-3",
        label: "Meus Depósitos",
        path: "/listagem-depositos",
        permission: "list_deposits",
      },
      {
        key: "2-4",
        label: "Simulador de taxas",
        path: "/simulador-taxas",
        permission: "simulate_taxes",
      },
    ],
  },
  {
    key: "3",
    icon: React.createElement(DeploymentUnitOutlined),
    label: "Operação",
    children: [
      {
        key: "3-1",
        label: "Credenciamento",
        path: "/credenciamento",
        permission: "register_account",
      },
      {
        key: "3-2",
        label: "Lojistas / Distribuidores",
        path: "/lojistas",
        permission: "list_accounts",
      },
      {
        key: "3-3",
        label: "Planos e taxas",
        path: "/planos-e-taxas",
        permission: "super_user",
      },
      {
        key: "3-5",
        label: "Planos base Zoop",
        path: "/planos-base-zoop",
        permission: "super_user",
      },
      {
        key: "3-4",
        label: "Terminais POS",
        path: "/terminais-pos",
        permission: "list_pos",
      },
    ],
  },
  {
    key: "4",
    icon: React.createElement(SafetyCertificateOutlined),
    label: "Risco & Compliance",
    permission: "list_transactions_dispute",
    children: [
      {
        key: "4-1",
        label: "Gestão de disputas",
        path: "/disputas",
        permission: "list_transactions_dispute",
      },
    ],
  },
  {
    key: "4.5",
    icon: React.createElement(WalletOutlined),
    label: "Contas Virtuais",
    permission: "super_user",
    children: [
      {
        key: "4.5-1",
        label: "Contas Virtuais",
        path: "/contas-virtuais",
        permission: "view_virtual_accounts",
      },
    ],
  },
  {
    key: "4.6",
    icon: React.createElement(CalendarOutlined),
    label: "Clap Tickets",
    permission: "super_user",
    children: [
      {
        key: "4.6-1",
        label: "Eventos",
        path: "/eventos",
        permission: "view_events",
      },
    ],
  },
  {
    key: "5",
    icon: React.createElement(ApiOutlined),
    label: "Integrações",
    children: [
      {
        key: "5-1",
        label: "Webhooks",
        path: "/webhooks",
        permission: "",
      },
      {
        key: "5-3",
        label: "ApiKey",
        path: "/apikey",
        permission: "",
      },
    ],
  },
  {
    key: "6",
    icon: React.createElement(ControlOutlined),
    label: "Sistema",
    permission: "manage_users",
    children: [
      {
        key: "6-1",
        label: "Usuários",
        path: "/admin/acessos",
        permission: "manage_users",
      },
      {
        key: "6-2",
        label: "Perfis",
        path: "/perfis",
        permission: "manage_groups",
      },
      {
        key: "6-3",
        label: "Estatísticas",
        path: "/estatisticas",
        permission: "super_user",
      },
      {
        key: "6-4",
        label: "Configurações",
        path: "/configuracoes-sistema",
        permission: "super_user",
      },
    ],
  },
  {
    key: "7",
    icon: React.createElement(PoweroffOutlined),
    label: "Sair",
    onClick: () => {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
    },
  },
];

const PanelLayout = ({ children }) => {
  const navigate = useNavigate();
  const isMobile = useIsMobileHook(1020);
  const location = useLocation();
  const [openUserMenu, setOpenUserMenu] = useState(false);
  const [accountModalOpen, setAccountModalOpen] = useState(false);

  useEffect(() => {
    if (!getItemFromStorage("menu")) {
      localStorage.setItem("menu", isMobile);
    }
  }, []);

  const onClick = (e) => {
    const { key } = e;
    const item = findMenuItemByKey(navItems, key);
    if (item) {
      if (item.onClick) {
        item.onClick();
      } else if (item.path) {
        navigate(item.path);
      }
    }
  };

  const findMenuItemByKey = (items, key) => {
    for (let item of items) {
      if (item.key === key) {
        return item;
      }
      if (item.children) {
        const found = findMenuItemByKey(item.children, key);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const [collapsed, setCollapsed] = useState(() => {
    return isMobile;
  });

  const toggleMenu = () => {
    let menuState = localStorage.getItem("menu");
    menuState = menuState === "true";
    menuState = !menuState;
    localStorage.setItem("menu", menuState);
    setCollapsed(menuState);
  };
  const toggleCollapsed = () => {
    toggleMenu();
  };

  const getSelectedKeys = (path) => {
    const keys = [];
    navItems.forEach((item) => {
      if (item.children) {
        item.children.forEach((child) => {
          if (child.path === path) {
            keys.push(child.key);
          }
        });
      } else if (item.path === path) {
        keys.push(item.key);
      }
    });
    return keys;
  };

  const filteredNavItems = navItems.filter((item) => {
    if (!userHasPermission(item.permission)) {
      return false;
    }
    item.children = item.children?.filter((child) => {
      if (!userHasPermission(child.permission)) {
        return false;
      }
      return true
    });
    return true;
  });

  const selectedKeys = getSelectedKeys(location.pathname);
  const openKeys = selectedKeys.map((key) => key.split("-")[0]);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseModal();
      }
    };

    if (openUserMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openUserMenu]);

  const handleCloseModal = () => {
    setOpenUserMenu(false);
  };

  const handleOpenModal = () => {
    setOpenUserMenu(true);
  };

  return (
    <Layout className={"PanelLayout"}>
      <Header
        className={"header"}
        style={{
          background: colorBgContainer,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "fixed",
          zIndex: 1000,
          width: "100%",
        }}
      >
        <img src={logo} alt="Logo" onClick={() => location.pathname === "/" ? window.location.reload() : navigate("/")} style={{ cursor: "pointer" }} />
        <div className="right-buttons">
          <Button type="text" onClick={toggleCollapsed}>
            {isMobile ? <MenuOutlined /> : <DesktopOutlined />}
          </Button>
          <Button
            type="text"
            ref={modalRef}
            onClick={openUserMenu ? handleCloseModal : handleOpenModal}
          >
            <UserOutlined />
            {openUserMenu && (
              <div className="container-user">
                <div className="header-user">
                  <span> {getUser().username}</span>
                  <p>
                    {isSuperUser()
                      ? "Super Usuário"
                      : "Vendedor"}
                  </p>
                </div>
                <div className="container-buttons-user">
                  <Button
                    onClick={() => {
                      setAccountModalOpen(true);
                      handleCloseModal();
                    }}
                  >
                    <SwapOutlined /> Trocar Conta
                  </Button>
                  <Button
                    onClick={() => {
                      localStorage.clear();
                      sessionStorage.clear();
                      window.location.href = "/login";
                    }}
                  >
                    <PoweroffOutlined /> Sair
                  </Button>
                </div>
              </div>
            )}
          </Button>
        </div>
      </Header>
      <Layout style={{ marginTop: 64 }}>
        <Sider
          // collapsible
          collapsed={collapsed}
          width={250}
          className="teste"
          style={{
            backgroundColor: "#001529",
            color: "white",
            height: "100%",
            position: "absolute",
            zIndex: 1,
            top: 64,
            left: 0,
            display: collapsed ? "none" : "block",
          }}
        >
          <Menu
            theme="dark"
            mode="inline"
            onClick={onClick}
            selectedKeys={selectedKeys}
            defaultOpenKeys={openKeys}
            style={{
              borderRight: 0,
              paddingBottom: "250px",
            }}
          >
            {filteredNavItems.map((item) =>
              item.children ? (
                <SubMenu key={item.key} title={item.label} icon={item.icon}>
                  {item.children.map((child) => (
                    <Menu.Item key={child.key} disabled={!child.path && true}>
                      {child.path ? (
                        <Link
                          onClick={() => isMobile && toggleCollapsed()}
                          to={child.path}
                        >
                          {child.label}
                        </Link>
                      ) : (
                        <span>{child.label}</span>
                      )}
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item
                  key={item.key}
                  icon={item.icon}
                  disabled={item.disabled}
                >
                  {item.path ? (
                    <Link
                      onClick={() => isMobile && toggleCollapsed()}
                      to={item.path}
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <span>{item.label}</span>
                  )}
                </Menu.Item>
              )
            )}
          </Menu>
        </Sider>
        <Layout
          style={{ marginLeft: collapsed ? 0 : 250, overflowX: "hidden" }}
        >
          <Layout style={{ overflowY: "scroll" }}>{children}</Layout>
        </Layout>
      </Layout>
      <AccountSelectionModal
        open={accountModalOpen}
        onClose={() => setAccountModalOpen(false)}
      />
    </Layout>
  );
};
export default PanelLayout;
